<script>

import ScrollsToTarget from "../../Mixins/ScrollsToTarget.js";
import HandlesConvertTests from "@/assets/js/frontend-v3/website/Mixins/Tests/HandlesConvertTests.js";

export default {

    name: 'GeneralEventHandler',

    mixins: [ScrollsToTarget, HandlesConvertTests],

    props: ['ip-valid'],

    data() {
        return {
            languageDropdownIsOpen: false,
        }
    },

    created() {
        this.isIpValid = this.ipValid ? true : false;
    },

    mounted() {

        //events

        this.Bus.on('set-tabs-sticky', () => {
            this.setPriceSectionSticky(true);
        });

        this.Bus.on('unset-tabs-sticky', () => {
            this.setPriceSectionSticky(false);
        });

        this.Bus.on('set-price-section-sticky-height', () => {
            this.setPriceSectionStickyHeight(true);
        });

        this.Bus.on('unset-price-section-sticky-height', () => {
            this.setPriceSectionStickyHeight(false);
        });

        this.Bus.on('toggle-review-translation', () => {
            this.toggleReviewTranslation();
        });

        this.Bus.on('scroll-to-price-information', () => {
            let targetTop = document.getElementById('price-information').offsetTop - 96;
            this.scrollTo(targetTop, 300);
        });

        this.Bus.on('scroll-to-price-section', () => {
            let target;
            let targetTop;

            if (this.showGridCalendar) {
                target = document.querySelector('section[data-section-reference="availability"]');
                targetTop = target.offsetTop - 80;
            } else {
                target = document.querySelector('aside[data-section-reference="price-section"]');
                targetTop = target.offsetTop - 96;
            }

            this.scrollTo(targetTop, 300);
        });

        this.Bus.on('favourite-house-set', (data) => {

            const houseCode = data.houseCode;
            const targetButton = document.querySelector('button[data-object-reference="' + houseCode + '"]');

            if (targetButton) {
                targetButton.classList.remove('active');
                const saveText = document.querySelector('button[data-object-reference="' + houseCode + '"] .fav-save');
                const savedText = document.querySelector('button[data-object-reference="' + houseCode + '"] .fav-saved');

                saveText.classList.add('hidden');
                savedText.classList.add('hidden');

                if (data.isSet) {
                    targetButton.classList.add('active');
                    savedText.classList.remove('hidden');
                } else {
                    saveText.classList.remove('hidden');
                }
            }
        });

        // Callback function for the Intersection Observer
        const handleIntersect = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.hideStartBookingButton();
                } else {
                    this.showStartBookingButton();
                }
            });
        };

        if (this.intersectTarget) {

            // Create an Intersection Observer instance
            this.observer = new IntersectionObserver(handleIntersect, {
                root: null, // Use the document's viewport as the container
                rootMargin: '0px',
                threshold: 0.1 // Trigger callback when 10% of the element is visible
            });

            // Start observing the target element
            this.observer.observe(this.intersectTarget);

            if (this.intersectTarget2) {
                this.observer.observe(this.intersectTarget2);
            }

            // Perform initial check
            const initialEntry = {
                target: this.intersectTarget,
                isIntersecting: this.isElementInViewport(this.intersectTarget),
                intersectionRatio: 1
            };

            handleIntersect([initialEntry], this.observer);
        }

        this.Bus.on('handle-bp-button-click', (url) => {
            if (url) {
                window.open(url, this.openBpInCurrentWindow ? '_self' : '_blank');

                if (this.openBpInCurrentWindow) {
                    this.Bus.emit('start-loading', 'fullscreenLoader');
                }
            }
        });

         this.determineVariation('open-bp-link-current-window');
    },

    watch: {
        showGridCalendar(newValue, oldValue) {
            this.setGridCalendar(newValue);
        },
    },

    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },

    methods: {

        setPriceSectionSticky(sticky) {

            const priceSection = document.querySelector('aside[data-section-reference="price-section"]');

            if (sticky) {
                priceSection.classList.add('active');
            } else {
                priceSection.classList.remove('active');
            }
        },

        setPriceSectionStickyHeight(sticky) {

            // const priceSection = document.querySelector('aside[data-section-reference="price-section"]');
            // const priceSectionXd = document.querySelector('aside[data-section-reference="price-section"] .price-section');
            //
            // priceSection.classList.add('pointer-events-none');
            // priceSectionXd.classList.add('pointer-events-auto');
            //
            // if (sticky) {
            //     priceSection.classList.add('h-120');
            // } else {
            //     priceSection.classList.remove('h-120');
            //     priceSection.classList.remove('pointer-events-none');
            // }
        },

        isElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },

        hideStartBookingButton() {
            const button = document.querySelector('.start-booking');
            button.classList.add('inactive');
        },

        showStartBookingButton() {
            const button = document.querySelector('.start-booking');
            button.classList.remove('inactive');
        },

        setGridCalendar(show) {

            const targetDivA = document.querySelector('[data-ab-test-target="calendar-a"]');
            const targetDivA2 = document.querySelector('aside[data-section-reference="price-section"]');
            const targetDivB = document.querySelector('[data-ab-test-target="calendar-b"]');

            if (show) {
                targetDivA.classList.add('h-0', 'overflow-hidden');
                targetDivB.classList.remove('hidden');

                if (window.innerWidth < 1024) {
                    targetDivA2.classList.add('h-0', 'overflow-hidden');
                }
            } else {
                targetDivA.classList.remove('h-0', 'overflow-hidden');

                if (targetDivB) {
                    targetDivB.classList.add('hidden');
                }

                if (window.innerWidth < 1024) {
                    targetDivA2.classList.remove('h-0', 'overflow-hidden');
                }
            }
        },

        toggleReviewTranslation() {
            // 1. Get the clicked button element.
            //    event.target might be the <span> inside the button, so .closest('button') ensures we get the button itself.
            const clickedButton = event.target.closest('button');

            if (clickedButton) {
                // 2. Use .closest() to find the nearest ancestor <div> with data-reference="review-text"
                const reviewTextContainer = clickedButton.closest('div[data-reference="review-text"]');

                if (reviewTextContainer) {

                    const currentTextSpan = reviewTextContainer.querySelector('[data-reference="review-text-current"]');
                    const originalTextSpan = reviewTextContainer.querySelector('[data-reference="review-text-original"]');
                    const originalButtonText = clickedButton.querySelector('[data-reference="text-original"]');
                    const translationButtonText = clickedButton.querySelector('[data-reference="text-translation"]');

                    if (currentTextSpan && originalTextSpan && originalButtonText && translationButtonText) {
                        currentTextSpan.classList.toggle('hidden');
                        originalTextSpan.classList.toggle('hidden');
                        originalButtonText.classList.toggle('hidden');
                        translationButtonText.classList.toggle('hidden');
                    }

                    const currentResponseSpan = reviewTextContainer.querySelector('[data-reference="review-response-current"]');
                    const originalResponseSpan = reviewTextContainer.querySelector('[data-reference="review-response-original"]');

                    if (currentResponseSpan && originalResponseSpan) {
                        currentResponseSpan.classList.toggle('hidden');
                        originalResponseSpan.classList.toggle('hidden');
                    }

                    const currentResponseHhSpan = reviewTextContainer.querySelector('[data-reference="review-response-hh-current"]');
                    const originalResponseHhSpan = reviewTextContainer.querySelector('[data-reference="review-response-hh-original"]');

                    if (currentResponseHhSpan && originalResponseHhSpan) {
                        currentResponseHhSpan.classList.toggle('hidden');
                        originalResponseHhSpan.classList.toggle('hidden');
                    }

                } else {
                    console.log('The parent div with data-reference="review-text" was not found.');
                }
            }
        }
    },

    computed: {
        showGridCalendar() {
            return this.isIpValid;
        },

        intersectTarget() {
            return document.querySelector('aside[data-section-reference="price-section"]');
        },

        intersectTarget2() {
            return document.querySelector('[data-ab-test-target="calendar-b"]');
        },

        openBpInCurrentWindow() {
            return false;
        },

    },

    render() {}
}

</script>

